import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const User = React.lazy(() =>
    import('../User')
);
const userRoutesRegistry = [
    {
        path: PAGE_URL.USER_PAGE,
        element: <User />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userRoutesRegistry;
